import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportModeComponent } from './transport-mode.component';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../common/pipes/pipes.module';
import { MaterialModule } from '../../material.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [TransportModeComponent],
  imports: [CommonModule, TranslateModule, PipesModule, MaterialModule, SvgIconModule],
  exports: [TransportModeComponent],
})
export class TransportModeModule {}
